import {Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy} from '@angular/core';
import {
  IModelDetails,
  IModelDetail
} from "@irb/irb-editors/irb-editors.model";
import { IrbEditorsService } from "@irb/irb-editors/irb-editors.service";
import { UtilityService } from '@irb/irb-common/services/utility.service';
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {AppService} from "@irb/app.service";
import {ReplaySubject, Subscription} from "rxjs";
import {IEvent, IEventSubscriber,IrbEditorsEvents, IrbModelsEvents} from "@irb-common/events";
import {takeUntil} from "rxjs/operators";
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

@Component({ standalone: false,
  selector: 'irb-com-assignments',
  templateUrl: './com-assignments.component.html',
  styleUrls: ['./com-assignments.component.scss', "../../editor-sidebar/editor-sidebar.component.scss"]
})
export class ComAssignmentsComponent implements OnInit, IEventSubscriber, OnDestroy {
  @Input('multipleporfolios') multipleporfolios: boolean = false;
  @Output() change = new EventEmitter<boolean>();
  @Input() selectedModel: IModelDetail = {} as IModelDetail;
  @Input() parentObj: any = null;
  @Output() selectedModelChange = new EventEmitter<IModelDetail>();
  @ViewChild('irbModelDropdown') irbModelDropdown: DropdownFilterComponent;
  @ViewChild('irbCustomCategoryDropdown') irbCustomCategoryDropdown: DropdownFilterComponent;
  _data: any;
  _modelDetails: IModelDetails;
  model: IModelDetail = {} as IModelDetail;
  selectedModelDDItem: IDropdownItem;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  eventSubscription: Subscription;

  constructor(
    private ies: IrbEditorsService,
    private util: UtilityService,
    private as: AppService,
    private ats: AnalyticsService
    ) { }

  ngOnInit() {
    const sortByKey = this.util.sortByKey;
    
    this.ies.getModelDetails().subscribe((data: any) => {
      this.modelDetails = data as IModelDetails;
      sortByKey(this.modelDetails.items, "securityModelName", "asc");

      if(!this.multipleporfolios) {
        this.modelDetails.items.unshift({ "securityModelId": null, "securityModelName": "None" } as IModelDetail);
      } else {
        this.modelDetails.items.unshift({ "securityModelId": "-1", "securityModelName": "None" } as IModelDetail);
      }


      if (this.data.securityModelId === 'Various') {
        this.modelDetails.items.push({ "securityModelId": "Various", "securityModelName": "Various" } as IModelDetail);
      }

      this.model = (this.data.securityModelId) ? this.modelDetails.items.find(x => x.securityModelId === this.data.securityModelId) : null;
      
      if(this.model) {
        this.selectedModelDDItem = {name: this.model.securityModelName, value: this.model}
        if (this.data) { this.selectedModelChange.emit(this.model); }
      }
    });

    this.eventSubscription = this.as.getEvents().pipe(takeUntil(this.destroyed$)).subscribe((s) => {
      this.processEvent(s);
    });
  }

  processEvent(event: IEvent) {
    switch (event.type) {
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
    if(this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  onInputChange() {
    if(this.model) {
      this.data.securityModelId = this.model?.securityModelId;
      this.selectedModelChange.emit(this.model);
    } else {
      this.data.securityModelId = null;
      this.selectedModelChange.emit(null);
    }
    
    this.change.emit(true);
  }

  getModelDropDownOptions(searchStr: string) {
    let f: Array<IDropdownItem> = [];
    let items: IDropdownItem[] = [];
    this.modelDetails?.items?.forEach((x:IModelDetail)=>{
      items.push({name: x.securityModelName, value: x});
    });
    this.irbModelDropdown.set(DropdownFilterComponent.getFilteredList(searchStr,items));
  }

  onModelDropDownChange(item: IDropdownItem) {
    this.ats.trackClickEvent("lc_edit_modelassign");
    this.model = item.value as IModelDetail;
    this.onInputChange();
  }
  
  @Input()
  get data(): any {
    return this._data;
  }

  set data(d: any) {
    this._data = d;
  }

  get modelDetails() {
    return this._modelDetails;
  }

  set modelDetails(md: IModelDetails) {
    this._modelDetails = md;
  }

  viewPortfolioModel() {
    let data: any =  {};
    data.slot ="B";
    data.isDraft = false;
    data.parentObj = this.parentObj;

    if(this.model && this.model.modelType ==="Blended") {
      let modelId = this.model.securityModelId.replace('b','').replace('B','');
      data.blendedSecurityModelId = modelId;
      data.modelId = modelId;
      data.type = this.model.modelType;
    } else {
      data.modelId = this.model.securityModelId;
      data.type = "Base";
    }
    if (!this.parentObj?.isModified) {
      this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MODEL, data);
    } else {
      if (this.parentObj) {
        this.parentObj.reloadAfterModelClosed = true;
        this.parentObj.checkForModifications(() => {
          this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MODEL, data);
          this.as.fireEvent(IrbEditorsEvents.CLOSE_WITHOUT_SAVE, {"slot": this.parentObj.slot});
        });
      }
    }
  }
}
